import { all, call, fork, takeLatest } from 'redux-saga/effects';

import { FETCH_OCCUPANCY_REPORT } from '../actions/types';

import { db } from 'config/firebase';
import { collection, getDocs, query, where } from 'firebase/firestore';

function* fetchOccupancyReport({ payload }) {
    try {
        const { orgProperties, resolve } = payload;

        const properties = Object.values(orgProperties).filter(p => p.type !== 'org' && p.type !== 'non-member');

        if (properties.length === 0) {
            resolve({ totalResi: 0, occupiedCount: 0, vacantCount: 0, vacantProperties: [] });
            return;
        }

        const propertyIds = properties.map(p => p.id);

        const chunkSize = 30;
        const usersByProperty = {};
        for (let i = 0; i < propertyIds.length; i += chunkSize) {
            const chunk = propertyIds.slice(i, i + chunkSize);
            const q = query(collection(db, 'users'), where('property_ids', 'array-contains-any', chunk));
            const snap = yield call(getDocs, q);
            snap.docs.forEach(d => {
                const user = d.data();
                (user.property_ids || []).forEach(pid => {
                    if (chunk.includes(pid)) {
                        if (!usersByProperty[pid]) usersByProperty[pid] = [];
                        usersByProperty[pid].push(user);
                    }
                });
            });
        }

        const vacantPropertyIds = propertyIds.filter(pid => !usersByProperty[pid]?.length);

        const ACTIVE_INVITE_STATUSES = ['pending_approval', 'invited'];
        const invitesByProperty = {};
        for (let i = 0; i < vacantPropertyIds.length; i += chunkSize) {
            const chunk = vacantPropertyIds.slice(i, i + chunkSize);
            const q = query(collection(db, 'invites'), where('property_id', 'in', chunk));
            const snap = yield call(getDocs, q);
            snap.docs.forEach(d => {
                const invite = d.data();
                if (!ACTIVE_INVITE_STATUSES.includes(invite.status)) return;
                const pid = invite.property_id;
                if (!invitesByProperty[pid]) invitesByProperty[pid] = [];
                invitesByProperty[pid].push(invite);
            });
        }

        const vacantProperties = vacantPropertyIds.map(pid => {
            const prop = orgProperties[pid];
            const pendingInvites = invitesByProperty[pid] || [];
            return {
                id: pid,
                address: prop.address,
                hasPendingInvite: pendingInvites.length > 0,
                pendingInviteCount: pendingInvites.length
            };
        });

        const totalResi = properties.length;
        const vacantCount = vacantProperties.length;
        const occupiedCount = totalResi - vacantCount;

        resolve({ totalResi, occupiedCount, vacantCount, vacantProperties });
    } catch (error) {
        console.error('Error fetching occupancy report:', error);
        payload.resolve({ error: error.message });
    }
}

export function* getOccupancyReport() {
    yield takeLatest(FETCH_OCCUPANCY_REPORT, fetchOccupancyReport);
}

export default function* rootSaga() {
    yield all([fork(getOccupancyReport)]);
}
